module.exports = __webpack_public_path__ + "img/flows.a719ebdc.png";